import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function HelpBodyClosedLeadCompanyTypes() {
    return (
        <OnboardingBody title='What are company type automations?'>
            <div>
                <p>
                    Nutshell supports company types to recognize the different companies you work
                    with. For example, you might track <i>Potential customer</i>, <i>Supplier</i>,{' '}
                    <i>Reseller</i> and <i>Customer</i>.
                </p>
                <p>
                    When a lead is won, you might ask Nutshell to automatically set{' '}
                    <i>Potential customer</i> to <i>Customer</i>, so you can easily segment your
                    list of businesses.
                </p>
            </div>
        </OnboardingBody>
    );
}
